import React, {ReactNode, useState} from 'react';
import {Button} from 'reactstrap';
import PomModal from '../Elements/PomModal';
import {handleFeedbackMovement} from '../services';
import Field from '../Elements/Field';

type FeedbackMovementProps = {
  id: number,
  feedbackFileCreated: string,
  endToEndId: string,
  amount: number,
  openingBalance: number,
  closingBalance: number,
  currency: string,
  name: string,
  account: string,
  feedbackFileIban: string,
  communication: string,
  status: string,
  type: string,
  raw: string,
  refundIban?: string,
  refundName?: string,
  forwardIban?: string,
  forwardName?: string,
  markAsHandledAccess: boolean,
  refundForwardAccess: boolean,
}

const FeedbackMovement = ({
                            id,
                            endToEndId,
                            amount,
                            openingBalance,
                            closingBalance,
                            currency,
                            name,
                            account,
                            feedbackFileIban,
                            feedbackFileCreated,
                            communication,
                            type,
                            status,
                            raw,
                            refundIban,
                            refundName,
                            forwardIban,
                            forwardName,
                            markAsHandledAccess,
                            refundForwardAccess,
                          }: FeedbackMovementProps) => {

  const refundAction = usePomModal({
    movementId: id,
    action: 'REFUND',
    title: "Refund",
    withReason: true,
    info: <div>
      Iban: {refundIban} <br/>
      Name: {refundName} <br/>
    </div>
  });

  const forwardAction = usePomModal({
    movementId: id,
    action: 'FORWARD',
    title: "Forward",
    withReason: true,
    info: <div>
      Iban: {forwardIban} <br/>
      Name: {forwardName} <br/>
    </div>
  });

  const markAsHandledAction = usePomModal({
    movementId: id,
    action: 'MARK_AS_HANDLED',
    title: "Mark as handled",
  });


  return (<div>
    <div className="row">
      <div className="col">
        <Field name="Document Id">{id}</Field>
        <Field name="Feedback Date">{feedbackFileCreated}</Field>
        <Field name="Type">{type}</Field>
        <Field name="End to end ID">{endToEndId}</Field>
        <Field name="Amount">{amount}</Field>
        <Field name="Opening Balance">{openingBalance}</Field>
        <Field name="Closing Balance">{closingBalance}</Field>
        <Field name="Currency">{currency}</Field>
        <Field name="Name">{name}</Field>
        <Field name="Account">{account}</Field>
        <Field name="FeedbackFileIban">{feedbackFileIban}</Field>
        <Field name="Communication">{communication}</Field>
        <Field name="Status">{status}</Field>
        <div className="d-flex">
            {markAsHandledAccess && (
                <Button className="m-1" color="success" onClick={() => markAsHandledAction.open()}>
                    Mark as handled
                </Button>
            )}
            {refundForwardAccess && (
                <>
                    <Button className="m-1" color="success" onClick={() => refundAction.open()}>Refund</Button>
                    <Button className="m-1" color="success" onClick={() => forwardAction.open()}>Forward</Button>
                </>
            )}
        </div>
      </div>
      <div className="col">
        <Field name="Raw">
          <pre>{raw}</pre>
        </Field>
      </div>
    </div>
    <div>
      {markAsHandledAction.modal()}
      {refundAction.modal()}
      {forwardAction.modal()}
    </div>

  </div>);
};

type PomModalProps = {
  movementId: number,
  action: 'REFUND' | 'FORWARD' | 'MARK_AS_HANDLED',
  title: string,
  withReason?: boolean,
  info?: ReactNode
}
const usePomModal = ({
                       movementId,
                       action,
                       title,
                       withReason = false,
                       info,
                     }: PomModalProps) => {

  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("");

  const open = () => setIsOpen(true);
  const close = () => {
    setIsOpen(false);
    setValue("");
    window.location.reload(true)
  };

  const onConfirm = () => handleFeedbackMovement(movementId, action, value).then(() => {
    return <div>done!</div>;
  });


  const actions = [{action: "Confirm", showFeedback: true, displayName: "Confirm"}];
  const modal = () =>
    isOpen ? (
      <PomModal
        showFeedback={true}
        onAction={onConfirm}
        isOpen={isOpen}
        onClose={close}
        title={title}
        actions={actions}
        hideSubmit={true}
      >
        {info}
        {withReason &&
            <textarea
                className="form-control my-2"
                rows={5}
                placeholder={"Please enter a reason"}
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
            />

        }
      </PomModal>
    ) : null;

  return {open, modal};
};


export {FeedbackMovement};
